export default __webpack_public_path__ + "static/media/PAFI_LKTT 2018.cbdbe7b3.pdf";